import { createFileRoute, Link } from '@tanstack/react-router'
import { Box, Typography, Button } from '@mui/material'

export const Route = createFileRoute('/$')({
  component: NotFoundPage,
})

function NotFoundPage() {
  return (
    <Box sx={{ textAlign: 'center', py: 8 }}>
      <Typography
        variant="h1"
        sx={{ fontSize: '6rem', fontWeight: 800, color: 'primary.main' }}
      >
        404
      </Typography>
      <Typography variant="h5" gutterBottom>
        Hmm, deze pagina bestaat niet.
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Misschien een typfout? Ga terug naar het dashboard en probeer het opnieuw.
      </Typography>
      <Button component={Link} to="/" variant="contained">
        Terug naar Dashboard
      </Button>
    </Box>
  )
}